module.exports = __webpack_public_path__ + "img/ic_24_whitelabel_support.c8b14ca1.svg";